import React from "react";
import { useDispatch, useSelector } from "react-redux";

import './CreateBranchForm.css';

import { changeBranchName, changeCreateBranchFormStatus, clearCreateBranchForm, createBranch, createBranchFormIsActive, creatingNewBranch, selectBranchName, selectConfirmingCreateBranch, selectCreateBranchFormStatus, setCreateBranchConfirming, toggleCreateBranchForm } from "./createBranchFormSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectUser } from "../home/userSlice";
import { selectToken } from "../login/loginSlice";

export default function CreateBranchForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const activeCreateForm = useSelector(createBranchFormIsActive);
    const branchName = useSelector(selectBranchName);
    const statusMessage = useSelector(selectCreateBranchFormStatus);
    const confirmingCreate = useSelector(selectConfirmingCreateBranch);
    const creatingBranch = useSelector(creatingNewBranch);

    const userInfo = useSelector(selectUser);
    const bankId = userInfo.bankId;

    const display = activeCreateForm ? "flex" : "none";

    const handleBranchNameChange = (event) => {
        dispatch(changeBranchName(event.target.value));
    }

    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(toggleCreateBranchForm());
        dispatch(clearCreateBranchForm());
    }

    const handleConfirmCancelClick = () => {
        dispatch(setCreateBranchConfirming(false))
    }

    const handleCreateBranchButtonClick = (event) => {
        event.preventDefault();

        if (!branchName) {
            dispatch(changeCreateBranchFormStatus('Branch name must not be blank'));
        } else {
            dispatch(setCreateBranchConfirming(true));
        }
    }

    const handleConfirmCreateClick = () => {
        const newBranch = {
            branchName: branchName,
            bankId: bankId,
            numOfAccounts: 0
        }
        dispatch(createBranch({newBranch, token}));
        dispatch(clearCreateBranchForm());
        dispatch(setCreateBranchConfirming(false));
    }

    return (
        <form className="form" style={{display:display, flexDirection:'column'}}>
            <h3>Create Branch</h3>
            <label>
                Branch Name:
                <input value={branchName} onChange={handleBranchNameChange}></input>
            </label>
            {!statusMessage ? "" : 
                <p className={statusMessage === 'Branch successfully created' ? 'confirmation' : 'error'}>{statusMessage}</p>
            }
            <div className="button-container">
                <button onClick={handleCancelButtonClick} disabled={creatingBranch}>Cancel</button>
                <button onClick={handleCreateBranchButtonClick} disabled={creatingBranch}>{creatingBranch ? "Creating New Branch" : "Create New Branch"}</button>
            </div>
            {confirmingCreate ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmCreateClick}/> : ""}
        </form>
    )
}